import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar } from "@mui/material";
import { useMemo } from "react";
import { defaultNetworkAssets } from "./core/index.js";
const NetworkAvatar = ({ network, AvatarProps = {}, forceNetworkBackgroundColor, }) => {
    const networkAssetInfo = useMemo(() => {
        return defaultNetworkAssets[network.id];
    }, [network]);
    const { sx: AvatarSx = {} } = AvatarProps;
    return (_jsx(Avatar, { "data-testid": `${network.id}-badge`, src: networkAssetInfo?.logoURI, ...AvatarProps, sx: {
            // Don't show background color when logo is present because some logos have transparency.
            ...(networkAssetInfo &&
                (!networkAssetInfo.logoURI || forceNetworkBackgroundColor) &&
                networkAssetInfo.color
                ? { backgroundColor: networkAssetInfo.color }
                : {}),
            width: 24,
            height: 24,
            fontSize: 16,
            ...AvatarSx,
        }, children: network.testnet && network.name.charAt(0) }));
};
export default NetworkAvatar;
